import React from "react";
import downArrow from "../../../assets/images/icons/angle-down.svg";
import inkindLogo from "../../../assets/images/enterprise/inkind/icons/ocp-logo.png";
import useIsMobile from "../../hooks/useIsMobile";
import offerCodeBg from "../../../assets/images/enterprise/inkind/icons/offercodeBG.jpg";
import offerCodeBgMobile from "../../../assets/images/enterprise/inkind/icons/offerbg-mobile.png";
import { RedeemGifting } from "./components/RedeemGifting";
import { NonOfferModal } from "./components/NonOfferModal";
import { NonOfferBrandLogo } from "./components/NonOfferBrandLogo";
import "./stylesheets/redeem-gifting.scss";

interface BrandDetails {
  hero_image: {
    native_height: number;
    native_width: number;
    value: string;
  };
  logo_image: {
    dark_mode: string | null;
    light_logo: string | null;
    light_mode: string | null;
    native_height: number;
    native_width: number;
    overlay: string | null;
  };
}

interface AppProps {
  redeemCode: string;
  qrCodeUrl: string;
  name: string;
  amount: string;
  locationCount: number;
  appStoreUrl: string;
  playStoreUrl: string;
  isRedeemGifting?: boolean;
  brandDetails?: BrandDetails;
  cloudinaryPath?: string;
}

const App: React.FC<AppProps> = ({
  redeemCode,
  qrCodeUrl,
  name,
  amount,
  locationCount,
  appStoreUrl,
  playStoreUrl,
  isRedeemGifting,
  brandDetails,
  cloudinaryPath,
}) => {
  const scrollTo = (where: string) => {
    document?.querySelector(where)?.scrollIntoView({
      behavior: "smooth",
    });
  };
  const isMobile = useIsMobile();
  const brandLogo = brandDetails?.logo_image?.dark_mode
    ? `${cloudinaryPath}${brandDetails.logo_image.dark_mode}`
    : null;
  const nonOfferBGImage = brandDetails?.hero_image
    ? `${cloudinaryPath}c_fit,w_1920/${brandDetails?.hero_image?.value.replace(
        /.png/i,
        ".jpg",
      )}`
    : offerCodeBg;
  const redeemGiftingBGImage = isMobile ? offerCodeBgMobile : offerCodeBg;

  return (
    <div
      className={`offers-main-container redeem-gifting ${!isRedeemGifting ? "non-offer-modal" : ""}`}
    >
      <div className="offers-main-content">
        <main className="offers-main">
          <div
            className="offers-brand-main-around"
            style={{
              backgroundImage: `url(${
                isRedeemGifting ? redeemGiftingBGImage : nonOfferBGImage
              })`,
            }}
          >
            <div
              className="header-brand-img-container"
              style={{ flexDirection: "row" }}
            >
              {isRedeemGifting ? (
                <img src={inkindLogo} alt="inkind logo" />
              ) : (
                <NonOfferBrandLogo brandLogo={brandLogo} />
              )}
            </div>
          </div>
          <div className="main-container">
            {isRedeemGifting ? (
              <RedeemGifting
                name={name}
                amount={amount}
                redeemCode={redeemCode}
                qrCodeUrl={qrCodeUrl}
                appStoreUrl={appStoreUrl}
                playStoreUrl={playStoreUrl}
              />
            ) : (
              <NonOfferModal
                appStoreUrl={appStoreUrl}
                playStoreUrl={playStoreUrl}
                locationCount={locationCount}
                stars={4.9}
                reviewsCount="29k"
              />
            )}
            <div
              className="map-show-container"
              style={{
                display: !isMobile && isRedeemGifting ? "flex" : "none",
              }}
            >
              <a
                className="map-show"
                onClick={(e) => {
                  scrollTo("#offers-map-section");
                }}
              >
                Explore locations
                <div className="map-show-arrow">
                  <img
                    src={downArrow}
                    alt="Scroll down"
                    className="down-arrow-offers bounce"
                  />
                </div>
              </a>
            </div>
          </div>
        </main>
      </div>
      {!isMobile && isRedeemGifting ? (
        <div className="map-box map-box-dark" id="offers-map-section">
          <div className="pass-map-header">
            {locationCount}+ Restaurants, Bars & Cafés
          </div>
          <iframe
            src="/embed/map?pass=true&colorMode=black"
            className="inkind-map"
            title="map"
          />
        </div>
      ) : null}
    </div>
  );
};

export default App;
